import { render } from "./FarmAction.vue?vue&type=template&id=7b812be0&scoped=true&ts=true"
import script from "./FarmAction.vue?vue&type=script&lang=ts"
export * from "./FarmAction.vue?vue&type=script&lang=ts"

import "./FarmAction.vue?vue&type=style&index=0&id=7b812be0&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b812be0"]])

export default __exports__